module.exports = __webpack_public_path__ + "img/customer-icon-8.6bcd9388.png";